import { eAtlas, Game } from "../../../Game";
import { AtlasAnimClip, AtlasAnimClipData } from "../../../Utils/Atlas/AtlasAnimClip";
import { ScaleManager } from "../../../Utils/ScaleManager";
import { TIMER } from "../../Gameplay";
import { IAnimMessage } from "./AnimMessageBase";



const enum eAnimMessageState {
    inactive,
    flipBookAnim,
    fadeToColor,
    fadeToTransparent,
}



/**
 * Zprava se zobrazi pres flip book animaci, nasledne zmeni barvu a nakonec zmizi pres alfu
 */
export class AnimMessage1 implements IAnimMessage {
    private static readonly SCALE = 1.25;

    private static readonly START_COLOR = new pc.Color(1, 1, 1);
    private static readonly FADE_COLOR = new pc.Color(1, 0.5, 0.5);

    private _entity: pc.Entity;
    private _textColor: pc.Color;
    private _animClip: AtlasAnimClip;

    private _posY: number;
    private _state: eAnimMessageState;
    private _stateTime: number;

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    constructor(screen: pc.Entity) {
        // Entita
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: new pc.Vec4(0.5, 1, 0.5, 1),
            pivot: new pc.Vec2(0.5, 0.5),
        });
        this._entity.enabled = false;
        screen.addChild(this._entity);

        // Barva textu
        this._textColor = new pc.Color();

        // Spravce animace
        this._animClip = new AtlasAnimClip(TIMER);

        // Stav
        this._state = eAnimMessageState.inactive;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    isActive(): boolean { return this._state != eAnimMessageState.inactive; }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    reset(): void {
        if (this._state != eAnimMessageState.inactive) {
            this._state = eAnimMessageState.inactive;

            this._entity.enabled = false;
            this._animClip.reset();

            Game.app.off(ScaleManager.EVENT_RESIZE, this.updateYPos, this);
        }
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    play(posY: number, anim: AtlasAnimClipData): boolean {
        if (this._state != eAnimMessageState.inactive)
            return false;

        this._posY = posY;
        this.updateYPos();

        this._textColor.set(1, 1, 1);
        this._animClip.play(anim);

        let element = this._entity.element;

        element.opacity = 1;
        element.color = this._textColor;
        element.texture = anim.atlas.texture;
        element.rect = this._animClip.curFrameRect;
        element.width = Math.round(Math.min(this._animClip.framePixSize.x * AnimMessage1.SCALE, Game.scale.width * 0.8));
        element.height = Math.round(this._animClip.framePixSize.y * (element.width / this._animClip.framePixSize.x));

        this._entity.enabled = true;

        // Zachytavat zmenu rozliseni
        Game.app.on(ScaleManager.EVENT_RESIZE, this.updateYPos, this);

        this._state = eAnimMessageState.flipBookAnim;
        return true;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    update(): boolean {
        switch (this._state) {
            case eAnimMessageState.inactive: {
                return false;
            }
            case eAnimMessageState.flipBookAnim: {
                if (this._animClip.update()) {
                    if (this._animClip.isPlaying) {
                        this._entity.element.rect = this._animClip.curFrameRect;
                    }
                    else {
                        this._state = eAnimMessageState.fadeToColor;
                        this._stateTime = TIMER.time;
                    }
                }

                break;
            }
            case eAnimMessageState.fadeToColor: {
                let progress = (TIMER.time - this._stateTime) / 500;

                if (progress >= 1) {
                    progress = 1;

                    this._state = eAnimMessageState.fadeToTransparent;
                    this._stateTime = TIMER.time;
                }

                this._textColor.lerp(AnimMessage1.START_COLOR, AnimMessage1.FADE_COLOR, progress);
                this._entity.element.color = this._textColor;

                break;
            }
            case eAnimMessageState.fadeToTransparent: {
                let progress = (TIMER.time - this._stateTime) / 500;

                if (progress >= 1) {
                    this.reset();
                    return false;
                }

                this._entity.element.opacity = 1 - progress;

                break;
            }
        }

        return true;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    private updateYPos(): void {
        this._entity.setLocalPosition(0, -Game.scale.minHeight * this._posY, 0);
    }
}